import _ from "lodash";

export const DATA_LIMIT = 10;
export const DATA_LIMIT_20 = 20;
export const SAVE_DATA_TIME_DELAY = 5000;

export const FACEBOOK_DASHBOARD_TABS_LIST = [
    {key: 'facebook-campaign', label: 'Campaign'},
    {key: 'facebook-targeting', label: 'Targeting'},
    {key: 'facebook-ad-set', label: 'Ad Set'},
    {key: 'facebook-ad-creative', label: 'Ad Creative'},
    {key: 'design-products', label: 'Design Products'},
    {key: 'parent-products', label: 'Parent Products'},
    {key: 'themes-quotes', label: 'Themes & Quotes'},
];


export const DEFAULT_FACEBOOK_DASHBOARD_TAB = {key: 'facebook-campaign', label: 'Campaign'};


export const FACEBOOK_INFO_IDS_LIST = {
    FACEBOOK_CAMPAIGNS: "facebook-campaigns",
    FACEBOOK_TARGETING: "facebook-targeting",
    FACEBOOK_AD_SETS: "facebook-ad-sets",
    FACEBOOK_AD_CREATIVES: "facebook-ad-creatives",
};


export const FACEBOOK_AD_OBJECTIVES = {
    OUTCOME_APP_PROMOTION: 'OUTCOME_APP_PROMOTION',
    OUTCOME_AWARENESS: 'OUTCOME_AWARENESS',
    OUTCOME_ENGAGEMENT: 'OUTCOME_ENGAGEMENT',
    OUTCOME_LEADS: 'OUTCOME_LEADS',
    OUTCOME_SALES: 'OUTCOME_SALES',
    OUTCOME_TRAFFIC: 'OUTCOME_TRAFFIC'
};

export const FACEBOOK_AD_OBJECTIVES_LIST = Object.entries(FACEBOOK_AD_OBJECTIVES).map(([key, label]) => ({key, label}));
export const FACEBOOK_AD_STATUSES = {
    ACTIVE: 'ACTIVE',
    PAUSED: 'PAUSED',
    DELETED: 'DELETED',
    ARCHIVED: 'ARCHIVED'
};

export const FACEBOOK_AD_STATUSES_LIST = Object.entries(FACEBOOK_AD_STATUSES).map(([key, label]) => ({key, label}));

export const FACEBOOK_SEARCH_TARGETING_TYPES: any = {
    INTEREST: 'adinterest',
    INTEREST_SUGGESTION: 'adinterestsuggestion',
    LOCATION: 'adgeolocation',
    EDUCATION: 'adeducationschool',
    MAJOR: 'adeducationmajor',
    WORK_POSITION: 'adworkposition',
    WORK_EMPLOYER: 'adworkemployer',
    FIELD_OF_STUDY: 'adstudy',
    LOCATION_CAT: 'adloc_category',
    DISTRICT: 'addistrict',
    EVENT: 'adevent',
    CUSTOM_AUDIENCE: 'custom_audience',
    GEO_MARKET: 'adgeomarket'
};

export const FACEBOOK_SEARCH_TARGETING_TYPE_LIST = Object.entries(FACEBOOK_SEARCH_TARGETING_TYPES)
    .map(([key, value]) => ({key: value, label: _.startCase(key)}));

export const FACEBOOK_SEARCH_TARGETING_LOCATION_TYPES = {
    COUNTRY: 'country',
    COUNTRY_GROUP: 'country_group',
    REGION: 'region',
    CITY: 'city',
    ZIP: 'zip',
    GEO_MARKET: 'geo_market',
    ELECTORAL_DISTRICT: 'electoral_district'
};

export const FACEBOOK_SEARCH_TARGETING_LOCATION_TYPES_LIST = Object.entries(FACEBOOK_SEARCH_TARGETING_LOCATION_TYPES)
    .map(([key, value]) => ({key: value, label: _.startCase(key)}));

export const OPTIMIZATION_GOALS = {
    IMPRESSIONS: "IMPRESSIONS",
    POST_ENGAGEMENT: "POST_ENGAGEMENT",
    REACH: "REACH",
    LINK_CLICKS: "LINK_CLICKS",
    LANDING_PAGE_VIEWS: "LANDING_PAGE_VIEWS",
};

export const OPTIMIZATION_GOALS_LIST = Object.entries(OPTIMIZATION_GOALS)
    .map(([key, value]) => ({key: value, label: _.startCase(key)}));

export const BILLING_EVENTS = {
    IMPRESSIONS: "IMPRESSIONS",
    LINK_CLICKS: "LINK_CLICKS",
    POST_ENGAGEMENT: "POST_ENGAGEMENT",
};

export const BILLING_EVENTS_LIST = Object.entries(BILLING_EVENTS)
    .map(([key, value]) => ({key: value, label: _.startCase(key)}));

export const FACEBOOK_AD_GENDERS = {
    ALL: 'all',
    MALE: '1',
    FEMALE: '2',
};

export const FACEBOOK_AD_GENDERS_LIST = Object.entries(FACEBOOK_AD_GENDERS)
    .map(([key, value]) => ({key: value, label: _.startCase(key)}));

export const FACEBOOK_AD_IMAGE_FIELDS = "hash,permalink_url";

export const FACEBOOK_AD_SET_ADS_FIELDS = "name,id,status";
